<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import SbRichtext from '$lib/storyblok/components/sbRichtext.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { type ButtonV3Props } from '../buttonV3.svelte';
	import { getSbUrl } from '$lib/utils/storyblok/url';

	interface Props {
		content: ISbStoryData<{
			eyebrow_label: string;
			headline: ISbRichtext;
			asset: ISbStoryData['content'][];
			cta: ISbStoryData<ButtonV3Props>['content'][];
		}>['content'];
	}

	let { content }: Props = $props();

	const link = getSbUrl(content.cta[0]?.link);
</script>

<div
	use:editable={content}
	class="group/teaser relative h-full overflow-hidden rounded-xl text-white"
>
	<div
		class="h-full select-none transition-transform duration-[640ms] lg:group-hover/teaser:scale-105"
	>
		{#each content.asset as asset}
			<Blok content={asset} />
		{/each}
	</div>

	<div class="absolute inset-0 flex flex-col justify-between p-5">
		{#if content.eyebrow_label}
			<div class="text-[16px]/[120%] tracking-[-.16px]">
				{content.eyebrow_label}
			</div>
		{/if}

		<div
			class="w-[70%] text-pretty text-[28px]/[120%] tracking-[-.28px] lg:text-[32px]/[110%] lg:tracking-[-.32px]"
		>
			<SbRichtext text={content.headline} />
		</div>

		<div class="z-20 flex gap-x-2">
			{#each content.cta as cta}
				<Blok content={cta} />
			{/each}
		</div>
	</div>

	{#if link}
		<a class="absolute inset-0 z-10 text-transparent" href={link}>click teaser</a>
	{/if}
</div>
